import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar/custom_nobreadcrumb";
import Footer from "examples/Footer";

// Wizard page components
import Content from "./content";

function getSteps() {
  return ["Content"];
}

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return <Content />;
    default:
      return null;
  }
}

function Wizard() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const isLastStep = activeStep === steps.length - 1;

  const handleNext = () => setActiveStep(activeStep + 1);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={8}>
        <Grid container justifyContent="center" sx={{ my: 4 }}>
          <Grid item xs={12} lg={8}>
            <MDBox mt={6} mb={8} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h2" fontWeight="bold">
                  U.S. Solar Sentiment
                </MDTypography>
              </MDBox>
              <MDTypography variant="h5" fontWeight="regular" color="secondary">
                2013-2022
              </MDTypography>
            </MDBox>
            <Card>
              <MDBox p={2}>
                {getStepContent(activeStep)}

                {/* First Button */}
                <MDBox
                  mt={4}
                  mb={2}
                  width="100%"
                  display="flex"
                  justifyContent="center"
                >
                  <MDButton
                    variant="gradient"
                    color="info"
                    sx={{ width: "300px" }}
                    onClick={() => (window.location.href = "./2022/cities2022#/2022/cities2022")}
                  >
                    EXPLORE THE DATA
                  </MDButton>
                </MDBox>

                {/* Second Button */}
                <MDBox
                  mt={2}
                  mb={4}
                  width="100%"
                  display="flex"
                  justifyContent="center"
                >
                  <MDButton
                    variant="gradient"
                    color="secondary"
                    sx={{ width: "300px" }}
                    onClick={() => (window.location.href = "https://huggingface.co/serenakim/solar-sentiment")}
                  >
                    VIEW MODEL ON HUGGINGFACE
                  </MDButton>
                </MDBox>

              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Wizard;